import React, { useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlass";
import "../main.scss";
import { agmsClientRequestGet, requestGet, agmsClientRequestPost, } from "../../../apis/request";
import Loading from "../../../assets/uxnicon/loadingIcon.png";
import moment from "moment";
import { useRecoilState, useSetRecoilState, atom } from "recoil";
import { userID } from "../../../states/recoilState";
import { Label } from "reactstrap";
import secureLocalStorage from "react-secure-storage";
import Button from '@mui/material/Button';
import { badgeOnOffAtom } from "../../../states/recoilState";

import AuditLogTable from "./Tables/AuditLogTable";
import AuditDeviceLogTable from "./Tables/AuditDeviceLogTable"

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from "react-i18next";

const AuditLogPage = () => {
  //const [badgeOnOffState, setBadgeOnOffState] = useRecoilState(badgeOnOffAtom);
  const { t:translate, i18n } = useTranslation();
  const [menu, setMenu]=useState(0);
  const [menuList, setMenuList] = useState([
    {
      id: 0,
      name : translate('secure_access')
    },
    {
      id: 1,
      name : translate('device_connection_log')
    }
  ]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [deviceLogData, setDeviceLogData] = useState(null);
  const [name, setName] = useState("");
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM"));
  const setuserID = useSetRecoilState(userID);
  const history = useHistory();
  
  const handleChange = (event) => {
    setMenu(event.target.value);
  };

  const hospitalMenuItemList = menuList.map((item, index) => {
    return <MenuItem key={index} value={item.id}>{item.name}</MenuItem>;
  });

  const callApi = async () => {
    // setLoading(true);
    // let idxObj = JSON.parse(secureLocalStorage.decoded);
    // try {
    //   let res = await requestGet(
    //     `/api/v1/user/staff-info/un-recognize/list/${idxObj.idx}`
    //   );
    //   setData(res);
    // } catch (error) {
    // } finally {
    //   setLoading(false);
    // }
    try{
      let listResult = await agmsClientRequestGet(`/api/accessRecord/list?user_id=${secureLocalStorage.getItem('authUser')}`);
      
      setData(listResult);
      
    }catch(error){

    }
  };

  const callDeviceApi = async () => {
    try{
      let listResult = await agmsClientRequestGet(`/api/device/patientDevice?user_id=${secureLocalStorage.getItem('authUser')}`);
      setDeviceLogData(listResult);
    }catch(error){

    }
     

  }
//   const callApproveApi = async(staff_id) => {
//     let approveResult = await agmsClientRequestPost(`/api/staff/approval/${staff_id}`);
//     // if(approveResult.message.conta){

//     // }
//     setBadgeOnOffState(staff_id);

//     alert('승인 되었습니다!');
//     callApi();
//   };

//   const callSearchApi = async () => {
//     setLoading(true);
//     // const params = new URLSearchParams();
//     // params.append("userName", name);
//     try {
//       let res = await requestGet(`/api/v1/staff/search/${name}`);
//       setData([res]);
//     } catch (error) {
//     } finally {
//       setLoading(false);
//     }
//   };

  useEffect(() => {
    setMenu(0);
 
  
    setData([
      {
       
      }
    ]);
  }, []);

  useEffect(() => {
    if (menu === 0) {
      callApi();
    } else {
      callDeviceApi();
    }
  }, [menu]);

  /*
  get(`/api1/v1/user/approval/list`)
  { id: data.id
    name : data.name,
    age : data.age,
    date : data.date,
    gender : data.gender,
    addres : data.addres,
    email : data.email,
    phonenumber : data.phonenumber
  }

  get(`/api/v1/login/attempt`)
  statuscode
  200~299 = 정상
  411 = 로그인 시도 있음
*/
  return (
    <div
      className="row w-100 h-100 d-flex align-items-center"
      style={{ 
        padding: "0px 70px", 
        marginTop: "30px",
        display:'flex', 
        justifyContent:'center',
        height:'100%'
        }}
    >

       

      <div style={{ maxWidth:'1500px'}}>
        <div style={{
          width: '100%', 
          height: '60px', 
          display:'flex', 
          alignItems:'center', 
          justifyContent:'end', 
          marginTop: '10px'}}>
            <FormControl sx={{ m: 1, width: 250, backgroundColor:'white' }} size="small" style={{margin:'0'}}>
              <InputLabel 
                id="demo-select-small-label"
                color="secondary">
                {translate('menu')}
              </InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={menu}
                label="메뉴 선택"
                color="secondary"
                onChange={handleChange}
              >
                {hospitalMenuItemList}
              </Select>
            </FormControl>
        </div>           
        {
          menu === 0 ? 
          <AuditLogTable 
            tableData = {data} 
          /> 
          :
          <AuditDeviceLogTable 
            tableData = {deviceLogData}
          />
        }
      </div>
    </div>
  );
};

export default withRouter(AuditLogPage);
